module.exports = "pegasus/assets/email1-column-5.png";